// extracted by mini-css-extract-plugin
module.exports = {"layout":"BlogPage_layout__UNBll"};